import React from 'react';
import { withBreakpoints } from '../components/Boneyard';
import TAEnrollmentPage from '../pageComponents/TALoginPage/TAEnrollmentPage';
import SiteLayout from '../components/SiteLayout';
import colors from '../theme/theme/colors.common.js';

function TaEnrollPage() {
  return (
    <SiteLayout
      title="Enrollment Page"
      hideNavOptions
      hideStadiumBanner
      backgroundColor={colors.taBackground}
    >
      <TAEnrollmentPage />
    </SiteLayout>
  );
}
export default withBreakpoints(TaEnrollPage);
